export default __webpack_public_path__ + "img/bg_auth_container-e57441b0ed0799e011e24f732bcd5945.png";